var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 27 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.125 8.375h-4.5v2.25h4.5A3.385 3.385 0 0 1 22.5 14a3.385 3.385 0 0 1-3.375 3.375h-4.5v2.25h4.5A5.627 5.627 0 0 0 24.75 14a5.627 5.627 0 0 0-5.625-5.625Zm-6.75 9h-4.5A3.385 3.385 0 0 1 4.5 14a3.385 3.385 0 0 1 3.375-3.375h4.5v-2.25h-4.5A5.627 5.627 0 0 0 2.25 14a5.627 5.627 0 0 0 5.625 5.625h4.5v-2.25ZM9 12.875h9v2.25H9v-2.25Z",
  fill: "currentColor"
})));

export default SvgCopy;